//区域管理
import http from '../jslibs/axios/http';
import dLAxiosFile from '@/jslibs/axios/download-file';
import dkAxiosFile from '@/jslibs/axios/axios-file';

//获取分类列表 
export const getArticleCategory = data => http.get('/cms/ArticleCategory', data);

//新增分类 
export const addArticleCategory = data => http.post('/cms/ArticleCategory', data);

//编辑分类 
export const editArticleCategory = data => http.put('/cms/ArticleCategory/' + data.uuid, data);

//删除分类 
export const deleteArticleCategory = data => http.delete('/cms/ArticleCategory/' + data.uuid);

//获取分类详情 
export const ArticleCategory = data => http.get('/cms/ArticleCategory/' + data.uuid);

//导出分类列表 
export const regionexport = data => dLAxiosFile({
	url: '/admin/region/export',
	method: 'GET',
	params: data
});


//获取资讯列表 
export const getArticle = data => http.get('/cms/Article', data);

//新增资讯 
export const addArticle = data => http.post('/cms/Article', data);

//编辑资讯 
export const editArticle = data => http.put('/cms/Article/'+data.uuid, data);

//删除资讯 
export const deleteArticle = data => http.delete('/cms/Article/' + data.uuid);

//获取资讯详情 
export const Article = data => http.get('/cms/Article/' + data.uuid);

//导出资讯列表 
export const ArticleExport = data => dLAxiosFile({
	url: '/admin/region/export',
	method: 'GET',
	params: data
});